import { Component, OnInit, inject } from '@angular/core';
import { APIAddress } from 'src/app/API/apiAddresses';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';
import { Company } from 'src/model/company.model';
import { Role } from 'src/model/role.model';
import { CompanyService } from 'src/services/company.service';
import { RegisterUserInfo, UserService } from 'src/services/user.service';

@Component({
    selector: 'app-register-user',
    templateUrl: './register-user.component.html',
    styleUrls: ['./register-user.component.scss'],
    standalone: false
})
export class RegisterUserComponent implements OnInit {
  private apiAddress = inject(APIAddress);
  private restapi = inject(RestApiService);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);
  private companyService = inject(CompanyService);
  private userService = inject(UserService);

  username: string;
  password: string;
  repeatPassword: string;

  initialCashAmount: number;
  initialAccountDate: Date;
  selectedCompany = 0;
  selectedRole = 0;

  showPassword = false;
  showRepeatPassword = false;

  companyList: Company[] = [];
  roleList: Role[] = [];

  ngOnInit(): void {
    this.getAllCompanies();
    this.getAllRoles();
  }

  private async getAllRoles() {
    this.roleList = await this.userService.getAllRoles();
    this.roleList.sort((a, b) => a.Name.toLowerCase().localeCompare(b.Name.toLowerCase()));
  }

  private async getAllCompanies() {
    this.companyList = await this.companyService.getAllCompanies();
    this.companyList.sort((a, b) => a.CompanyCode.toLowerCase().localeCompare(b.CompanyCode.toLowerCase()));
  }

  validateField(): boolean {
    const errors: string[] = [];
    const prefix = '❌';

    //username
    if (this.username == undefined || this.username.length < 6) {
      errors.push("Username must contain more than 6 characters");
    }

    //password
    const format = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (this.password == undefined || this.password.length <= 10) {
      errors.push("Password must at least contain more than 10 characters");
    }
    else if (this.password !== this.repeatPassword) {
      errors.push("Password and confirm password are different!");
    }
    else if (format.test(this.password) == false) {
      errors.push("Password must contain at least a special character : @!-_?]/&*^%$");
    }

    //check company if not admin
    // this.sharedService.openAlert(this.selectedRoleID +"|"+this.selectedRole)
    if (!this.selectedRole)
      errors.push("Please select your role");
    else {
      if (this.includesSelectedRole([this.enums.STAFF, this.enums.BRANCH_MANAGER, this.enums.BRANCH_MANAGER_HEAD, this.enums.BOOKKEEPING_STAFF])) {
        if (!this.selectedCompany)
          errors.push("Please select your company before proceed");

        if (this.initialCashAmount == undefined)
          errors.push("Please fill in your initial cash amount");

        if (this.initialAccountDate == undefined)
          errors.push("Please fill in your initial cash account date");
      }
    }

    if (errors.length > 0)
      this.sharedService.openAlert(errors.map(e => `${prefix} ${e}`).join('\n'), ALERT_TYPE.DANGER);
    return errors.length === 0;
  }

  async registerUser() {
    if (this.validateField()) {
      let data: RegisterUserInfo = { username: this.username, password: this.password, roleId: this.selectedRole };
      if (this.includesSelectedRole([this.enums.STAFF, this.enums.BRANCH_MANAGER, this.enums.BRANCH_MANAGER_HEAD, this.enums.BOOKKEEPING_STAFF])) {
        data = { ...data, companyId: this.selectedCompany, initialAccountBalance: this.initialCashAmount, initialAccountDate: this.initialAccountDate, salary: 0 }
      }
      await this.userService.postRegisterUser(data);
      this.sharedService.openAlert("Successfully registered your account!", ALERT_TYPE.SUCCESS)
      this.reset();
    }
  }

  reset() {
    this.username = "";
    this.password = "";
    this.repeatPassword = "";
    this.selectedCompany = 0;
    this.selectedRole = 0;
  }

  addCashAccount() {
    const companyId = Number(sessionStorage.getItem('companyId'));
    // var loggedInUsername = sessionStorage.getItem('username');

    const data = {
      "name": this.username + "'s CASH ACCOUNT",
      "holderName": this.username,
      "companyId": companyId,
      "username": this.username
    };

    const xhr = this.restapi.postRequest(this.apiAddress.ADD_ACCOUNT, data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        const json = JSON.parse(xhr.responseText);

        const cashAccount = new Account(json.id, json.accountNumber, json.name, json.holdername, json.balnce, json.companyid, json.username);

        // this.passEntry.emit(customer);
        this.sharedService.openAlert("Successfully added CASH ACCOUNT!", ALERT_TYPE.SUCCESS);
      }
    }
  }

  includesSelectedRole(roles: number[]): boolean {
    return roles.includes(Number(this.selectedRole));
  }
}
